export const CORRECT_NBN_ORDER_REQUEST_TYPE = "Correct NBN Order";

export const HIDDEN_AUDIT_HISTORY_FIELDS = [
  "id",
  "contractterm",
  "address",
  "serviceid",
  "radiususername",
  "radiuspassword"
];

export const HIDDEN_AUDIT_HISTORY_REQUEST_TYPES = ["updatenbnorder"];

export const NBN_ORDER_CORRECTION_STATUSES = [
  "Submitted",
  "InProgress",
  "Held",
  "OnHold",
  "Scheduled",
  "Updating",
  "Complete",
  "Cancelled",
  "Disconnecting",
  "Disconnected",
  "Rejected",
  "Transferred Out"
];

export const NBN_ORDER_CORRECTION_FIELDS = [
  {
    key: "CustomerReference",
    label: "Customer Reference",
    aliases: ["customerReference", "customerRef"],
    readOnly: true
  },
  {
    key: "CustomerFirstname",
    label: "Customer First Name",
    aliases: ["customerFirstname"]
  },
  {
    key: "CustomerSurname",
    label: "Customer Surname",
    aliases: ["customerSurname"]
  },
  {
    key: "CustomerContactNo",
    label: "Customer Contact No.",
    aliases: ["customerContactNo", "customerContactNumber"]
  },
  {
    key: "CustomerContactEmail",
    label: "Customer Contact Email",
    aliases: ["customerContactEmail"]
  },
  {
    key: "CustomerAuthDate",
    label: "Customer Auth Date",
    aliases: ["customerAuthDate", "customerAuthorityDate"]
  },
  {
    key: "AvcId",
    label: "AVC ID",
    aliases: ["avcId"]
  },
  {
    key: "Product",
    label: "Product",
    aliases: ["product", "productType"],
    readOnly: true
  },
  {
    key: "RequestType",
    label: "Request Type",
    aliases: ["requestType"],
    readOnly: true
  },
  {
    key: "Status",
    label: "Status",
    aliases: ["status"],
    input: "status"
  },
  {
    key: "NbnOrderId",
    label: "NBN Order ID",
    aliases: ["nbnOrderId"],
    readOnly: true
  },
  {
    key: "LocationId",
    label: "Location ID",
    aliases: ["locationId"],
    readOnly: true
  },
  {
    key: "Wholesaler",
    label: "Wholesaler",
    aliases: ["wholesaler"],
    input: "wholesaler"
  },
  {
    key: "WholesalerAccountNumber",
    label: "Wholesaler Account Number",
    aliases: ["wholesalerAccountNumber"],
    disabled: true
  },
  {
    key: "AvcdBandwidthProfile",
    label: "AVC Bandwidth Profile",
    aliases: [
      "avcdBandwidthProfile",
      "avcBandwidthProfile",
      "bandwidthProfile"
    ],
    input: "bandwidth"
  }
];
